/* eslint-disable no-console */
import * as React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import {
  getRoomIconById,
  IRemoteTableColumn,
  ISortChangeEvent,
  RemoteTable,
  RoomLevelPowerConsumptionDto
} from '../../..';
import { Text } from '../../../components/Text';
import { DevicesStateBox } from '../../../components/DevicesStateBox';
import { EmptyTable } from '../../../components/EmptyTable';
import { PowerProgressBar } from '../../../components/PowerProgressBar';
import { Location } from '../../../components/icons';

const StyledActualConsumptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const StyledActualConsumptionValue = styled(Text)`
  margin-right: 10px;
  color: ${({ theme }) => theme.colors.font1};
`;

export const getLocationAnalyticsColumns = (
  roomsData: RoomLevelPowerConsumptionDto[]
) => {
  return [
    { key: 'roomId', name: 'roomId', hide: true },
    {
      key: 'icon',
      name: '',
      custom: true,
      customComponent: (row: RoomLevelPowerConsumptionDto) => {
        return <>{getRoomIconById(row.typeId, 'room-btn__icon')}</>;
      },
      disableSort: true,
      headerStyle: { width: '56px' },
      rowStyle: { width: '100%' }
    },
    {
      key: 'roomName',
      name: 'Room',
      custom: true,
      disableSort: true,
      customComponent: (row: RoomLevelPowerConsumptionDto) => (
        <>{row.roomName}</>
      ),
      rowStyle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    {
      key: 'roomPowerConsumption',
      name: 'Power consumption',
      custom: true,
      customComponent: (row: RoomLevelPowerConsumptionDto) => {
        const locationPowerSum = _.sum(
          roomsData.map(room => room.roomPowerConsumption.power)
        );
        return (
          <StyledActualConsumptionRow>
            <StyledActualConsumptionValue>
              {row.roomPowerConsumption.power} W
            </StyledActualConsumptionValue>
            <PowerProgressBar
              currentValue={row.roomPowerConsumption.power}
              maxValue={locationPowerSum}
            />
          </StyledActualConsumptionRow>
        );
      },
      rowStyle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    {
      key: 'smartPowerConsumption',
      name: 'Smart Powers',
      custom: true,
      customComponent: (row: RoomLevelPowerConsumptionDto) => (
        <div>{row.smartPowerConsumption.power} W</div>
      ),
      rowStyle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    {
      key: 'relayPowerConsumption',
      name: 'Regular Relays',
      custom: true,
      customComponent: (row: RoomLevelPowerConsumptionDto) => (
        <div>{row.relayPowerConsumption.power} W</div>
      ),
      rowStyle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    {
      key: 'workingDevices',
      name: 'Devices On',
      custom: true,
      customComponent: (row: RoomLevelPowerConsumptionDto) => {
        return <DevicesStateBox devicesTurnedOn={row.workingDevicesNumber} />;
      },
      align: 'center',
      disableSort: true,
      headerStyle: { width: '160px', textAlign: 'left' }
    }
  ] as IRemoteTableColumn[];
};

export interface ILocationAnalyticsTableProps {
  tableData: RoomLevelPowerConsumptionDto[];
  onRowClick: (rowId: string) => void;
  onSortChange: (event: ISortChangeEvent) => void;
}

const LocationAnalyticsTable: React.FunctionComponent<ILocationAnalyticsTableProps> = props => {
  const { tableData, onSortChange, onRowClick } = props;

  return (
    <>
      <RemoteTable
        tableTestId="location_analytics_table"
        className="location_analytics_table"
        onSortChange={key => onSortChange(key)}
        onRowClick={row => {
          onRowClick(row.roomId);
        }}
        columns={getLocationAnalyticsColumns(tableData)}
        data={tableData}
        onLoadMore={() => console.log('loadmore')}
        showMoreButton={false}
        emptyTableComponent={
          <EmptyTable
            icon={
              <Location
                className="empty-list-indicator-icon"
                height="18vh"
                width="18vh"
              />
            }
            title="No analytics for locations"
            description={
              <>
                All analytics data will be displayed here. <br />
              </>
            }
          />
        }
      />
    </>
  );
};

export default LocationAnalyticsTable;
